/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис реализует функционал управления оповещениями о проблемах сбора показаний телеметрии (алертинга)
 */

/**
 * Сервис алертинга
 */
export class TriggerServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения триггера.
   * Поддерживает создание и обновление.
   * Метод доступен для: service, application(telemetry:edit)
   */
  PostTrigger = (req: PostTriggerRequestDto, init?: RequestInit): Promise<PostTriggerResponseDto> => {
    return fm.request<PostTriggerRequestDto, PostTriggerResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Чтение одного триггера.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetTrigger = (req: GetTriggerRequestDto, init?: RequestInit): Promise<GetTriggerResponseDto> => {
    return fm.request<GetTriggerRequestDto, GetTriggerResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка триггеров.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetTriggerList = (req?: GetTriggerListRequestDto, init?: RequestInit): Promise<GetTriggerListResponseDto[]> => {
    return fm.list<GetTriggerListRequestDto, GetTriggerListResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества триггеров.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetTriggerCount = (req?: GetTriggerCountRequestDto, init?: RequestInit): Promise<GetTriggerCountResponseDto> => {
    return fm.request<GetTriggerCountRequestDto, GetTriggerCountResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Удаление триггера.
   * Метод удаляет только отключенный триггер (is_disabled=true).
   * Удаление неотключенного вызовет ошибку.
   * При удалении триггера удаляются и все его алерты.
   * Метод доступен для: service, application(telemetry:edit)
   */
  DeleteTrigger = (req: DeleteTriggerRequestDto, init?: RequestInit): Promise<DeleteTriggerResponseDto> => {
    return fm.request<DeleteTriggerRequestDto, DeleteTriggerResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка алертов.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetTriggerAlertList = (req?: GetTriggerAlertListRequestDto, init?: RequestInit): Promise<GetTriggerAlertListResponseDto[]> => {
    return fm.list<GetTriggerAlertListRequestDto, GetTriggerAlertListResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/alert/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества алертов.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetTriggerAlertCount = (req?: GetTriggerAlertCountRequestDto, init?: RequestInit): Promise<GetTriggerAlertCountResponseDto> => {
    return fm.request<GetTriggerAlertCountRequestDto, GetTriggerAlertCountResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/alert/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Удаление алерта.
   * Метод удаляет только погашенный алерт (is_disabled=true).
   * Удаление непогашенного вызовет ошибку.
   * Метод доступен для: service, application(telemetry:edit)
   */
  DeleteTriggerAlert = (req: DeleteTriggerAlertRequestDto, init?: RequestInit): Promise<DeleteTriggerAlertResponseDto> => {
    return fm.request<DeleteTriggerAlertRequestDto, DeleteTriggerAlertResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/alert/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Принудительное выключение алерта.
   * Дата closed_at проставляется текущим временем.
   * Флаг is_disabled проставляется true.
   * Флаг is_manually_closed проставляется true.
   * Можно принудительно выключать только алерты созданные по триггерам с атрибутом manually_unclosable=false.
   * Метод доступен для: service, application(telemetry:edit)
   */
  PostTriggerAlertDisable = (req: PostTriggerAlertDisableRequestDto, init?: RequestInit): Promise<PostTriggerAlertDisableResponseDto> => {
    return fm.request<PostTriggerAlertDisableRequestDto, PostTriggerAlertDisableResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/alert/${encodeURIComponent(req.id)}/disable`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Список устройств, вызвавших появление алерта.
   * Метод доступен для: service, application(telemetry:read или telemetry:edit)
   */
  GetTriggerAlertDeviceList = (req: GetTriggerAlertDeviceListRequestDto, init?: RequestInit): Promise<GetTriggerAlertDeviceListResponseDto[]> => {
    return fm.list<GetTriggerAlertDeviceListRequestDto, GetTriggerAlertDeviceListResponseDto>(`${this.host}/telemetry_alerting/api/v1/trigger/alert/${encodeURIComponent(req.id)}/device/list${fm.buildQuery(req, ["id"])}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
}

/**
 * Справочник типов критерия триггера.
 * Задает параметры критерия, правила поиска проблемы и генерации алерта
 */
export enum TriggerCriteriaType {
  /**
   * Значение не указано
   */
  CRITERIA_TYPE_UNKNOWN = "CRITERIA_TYPE_UNKNOWN",
  /**
   * Количество метрик меньше порога
   */
  METRICS_COUNT = "METRICS_COUNT",
  /**
   * Доля работающих устройств в группе меньше порога
   */
  DEVICE_PERCENT = "DEVICE_PERCENT",
  /**
   * Превышение порога дисперсии значений показаний
   */
  METRICS_VALUE_DEVIATION = "METRICS_VALUE_DEVIATION",
}
/**
 * Справочник типов критерия триггера.
 * Задает параметры критерия, правила поиска проблемы и генерации алерта
 */
export type TriggerCriteriaTypeResponseEnum = keyof typeof TriggerCriteriaType
/**
 * Справочник типов критерия триггера.
 * Задает параметры критерия, правила поиска проблемы и генерации алерта
 */
export type TriggerCriteriaTypeRequestEnum = Exclude<TriggerCriteriaTypeResponseEnum, "CRITERIA_TYPE_UNKNOWN">;

/**
 * Справочник типов ПУ
 */
export enum TriggerDeviceType {
  /**
   * Значение не указано
   */
  DEVICE_TYPE_UNKNOWN = "DEVICE_TYPE_UNKNOWN",
  /**
   * Коммуникационный модуль
   */
  HUB = "HUB",
  /**
   * Счетчик импульсов - регистратор
   */
  PULSE_COUNTER_RECORDER = "PULSE_COUNTER_RECORDER",
  /**
   * Счетчик импульсов - регистратор LoRaWAN
   */
  PULSE_COUNTER_RECORDER_LR = "PULSE_COUNTER_RECORDER_LR",
  /**
   * Прибор учета расхода коммунальных услуг
   */
  METERING_DEVICE = "METERING_DEVICE",
  /**
   * Конвертер интерфейсов
   */
  INTERFACE_CONVERTER = "INTERFACE_CONVERTER",
  /**
   * M-BUS концентратор
   */
  M_BUS_HUB = "M_BUS_HUB",
  /**
   * Модуль связи LoRaWAN
   */
  COMMUNICATION_MODULE_LR = "COMMUNICATION_MODULE_LR",
  /**
   * Базовая станция LoRaWAN
   */
  BASE_LR = "BASE_LR",
}
/**
 * Справочник типов ПУ
 */
export type TriggerDeviceTypeResponseEnum = keyof typeof TriggerDeviceType
/**
 * Справочник типов ПУ
 */
export type TriggerDeviceTypeRequestEnum = Exclude<TriggerDeviceTypeResponseEnum, "DEVICE_TYPE_UNKNOWN">;

/**
 * Типы группировок метрик при вычислении критерия
 */
export enum TriggerMetricGroupingType {
  /**
   * Значение не указано
   */
  METRIC_GROUPING_TYPE_UNKNOWN = "METRIC_GROUPING_TYPE_UNKNOWN",
  /**
   * Признак группировки метрик по идентификаторам родительского устройства(идентификатор хаба, проксирующего прибор учета)
   */
  PARENT_ID = "PARENT_ID",
  /**
   * Признак группировки метрик по идентификатору устройства(устройство, с которого получена метрика)
   */
  DEVICE_ID = "DEVICE_ID",
}
/**
 * Типы группировок метрик при вычислении критерия
 */
export type TriggerMetricGroupingTypeResponseEnum = keyof typeof TriggerMetricGroupingType
/**
 * Типы группировок метрик при вычислении критерия
 */
export type TriggerMetricGroupingTypeRequestEnum = Exclude<TriggerMetricGroupingTypeResponseEnum, "METRIC_GROUPING_TYPE_UNKNOWN">;

/**
 * Справочник типов энергоресурсов, собираемых ТУ
 */
export enum TriggerMetricType {
  /**
   * Значение не указано
   */
  METRIC_TYPE_UNKNOWN = "METRIC_TYPE_UNKNOWN",
  /**
   * Горячая вода
   */
  HOT_WATER = "HOT_WATER",
  /**
   * Холодная вода
   */
  COLD_WATER = "COLD_WATER",
  /**
   * Теплоэнергия
   */
  HEAT = "HEAT",
  /**
   * Газ
   */
  GAS = "GAS",
  /**
   * Электроэнергия
   */
  ELECTRICITY = "ELECTRICITY",
}
/**
 * Справочник типов энергоресурсов, собираемых ТУ
 */
export type TriggerMetricTypeResponseEnum = keyof typeof TriggerMetricType
/**
 * Справочник типов энергоресурсов, собираемых ТУ
 */
export type TriggerMetricTypeRequestEnum = Exclude<TriggerMetricTypeResponseEnum, "METRIC_TYPE_UNKNOWN">;

/**
 * Справочник типов периодов контроля триггера
 */
export enum TriggerPeriodType {
  /**
   * Значение не указано
   */
  PERIOD_TYPE_UNKNOWN = "PERIOD_TYPE_UNKNOWN",
  /**
   * День
   */
  DAY = "DAY",
  /**
   * Месяц
   */
  MONTH = "MONTH",
}
/**
 * Справочник типов периодов контроля триггера
 */
export type TriggerPeriodTypeResponseEnum = keyof typeof TriggerPeriodType
/**
 * Справочник типов периодов контроля триггера
 */
export type TriggerPeriodTypeRequestEnum = Exclude<TriggerPeriodTypeResponseEnum, "PERIOD_TYPE_UNKNOWN">;

/**
 * Справочник типов уровней критичности
 */
export enum TriggerSeverityType {
  /**
   * Значение не указано
   */
  SEVERITY_TYPE_UNKNOWN = "SEVERITY_TYPE_UNKNOWN",
  /**
   * Проблема высшего приоритета.
   * Максимальное оповещение
   */
  CRITICAL = "CRITICAL",
  /**
   * Проблема среднего приоритета.
   * Оповещение по внутренним каналам
   */
  WARNING = "WARNING",
  /**
   * Проблема не влияет на бизнес-пользователя.
   * Отражается во внутренних интерфейсах
   */
  INFO = "INFO",
}
/**
 * Справочник типов уровней критичности
 */
export type TriggerSeverityTypeResponseEnum = keyof typeof TriggerSeverityType
/**
 * Справочник типов уровней критичности
 */
export type TriggerSeverityTypeRequestEnum = Exclude<TriggerSeverityTypeResponseEnum, "SEVERITY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum TriggerAlertPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type TriggerAlertPagingDirectionTypeResponseEnum = keyof typeof TriggerAlertPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type TriggerAlertPagingDirectionTypeRequestEnum = Exclude<TriggerAlertPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum TriggerAlertPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По дате возникновения
   */
  RAISED_AT = "RAISED_AT",
  /**
   * По идентификатору триггера
   */
  TRIGGER_ID = "TRIGGER_ID",
  /**
   * По заголовку триггера
   */
  TITLE = "TITLE",
  /**
   * По флагу активности триггера
   */
  DISABLED = "DISABLED",
  /**
   * По триггеру
   */
  SEVERITY = "SEVERITY",
}
/**
 * Справочник типов значений сортировки
 */
export type TriggerAlertPagingOrderByTypeResponseEnum = keyof typeof TriggerAlertPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type TriggerAlertPagingOrderByTypeRequestEnum = Exclude<TriggerAlertPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum TriggerPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type TriggerPagingDirectionTypeResponseEnum = keyof typeof TriggerPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type TriggerPagingDirectionTypeRequestEnum = Exclude<TriggerPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum TriggerPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По заголовку
   */
  TITLE = "TITLE",
  /**
   * По флагу активности
   */
  DISABLED = "DISABLED",
  /**
   * По Severity
   */
  SEVERITY = "SEVERITY",
}
/**
 * Справочник типов значений сортировки
 */
export type TriggerPagingOrderByTypeResponseEnum = keyof typeof TriggerPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type TriggerPagingOrderByTypeRequestEnum = Exclude<TriggerPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Факты сработки алерта на устройствах
 */
export type AlertDeviceRequestDto = {
  /**
   * Идентификатор алерта
   */
  alertId: number
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Факты сработки алерта на устройствах
 */
export type AlertDeviceResponseDto = {
  /**
   * Идентификатор алерта
   */
  alertId: number
  /**
   * Идентификатор устройства
   */
  deviceId: number
}
/**
 * Запрос на удаление алерта
 */
export type DeleteTriggerAlertRequestDto = {
  /**
   * Идентификатор алерта
   */
  id: number
}
/**
 * Ответ на запрос удаление алерта
 */
export type DeleteTriggerAlertResponseDto = {
}
/**
 * Запрос на удаление триггера
 */
export type DeleteTriggerRequestDto = {
  /**
   * Идентификатор триггера
   */
  id: number
}
/**
 * Ответ на запрос удаление триггера
 */
export type DeleteTriggerResponseDto = {
}
/**
 * Запрос получения списка алертов
 */
export type GetTriggerAlertCountRequestDto = {
  /**
   * Параметры фильтрации
   */
  filter?: TriggerAlertFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества записей
 */
export type GetTriggerAlertCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего записей
   */
  readonly data: number
}>
/**
 * Запрос списка устройств, вызвавших появление алерта
 */
export type GetTriggerAlertDeviceListRequestDto = {
  /**
   * Идентификатор алерта
   */
  id: number
  /**
   * Параметры фильтрации алерта
   */
  filter?: TriggerAlertFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Параметры пагинации
   */
  readonly paging: TriggerAlertPagingRequestDto
}>
/**
 * Ответ на запрос списка устройств, вызвавших появление алерта
 */
export type GetTriggerAlertDeviceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Факт сработки триггера
   */
  readonly data: AlertDeviceResponseDto
}>
/**
 * Запрос получения списка алертов
 */
export type GetTriggerAlertListRequestDto = {
  /**
   * Параметры фильтрации
   */
  filter?: TriggerAlertFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Параметры пагинации
   */
  readonly paging: TriggerAlertPagingRequestDto
}>
/**
 * Ответ на запрос получения списка записей
 */
export type GetTriggerAlertListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Алерт
   */
  readonly data: TriggerAlertResponseDto
}>
/**
 * Запрос получения количества записей
 */
export type GetTriggerCountRequestDto = {
  /**
   * Параметры фильтрации
   */
  filter?: TriggerFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества записей
 */
export type GetTriggerCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего записей
   */
  readonly data: number
}>
/**
 * Запрос получения списка триггеров
 */
export type GetTriggerListRequestDto = {
  /**
   * Параметры фильтрации
   */
  filter?: TriggerFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Параметры пагинации
   */
  readonly paging: TriggerPagingRequestDto
}>
/**
 * Ответ на запрос получения списка записей
 */
export type GetTriggerListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Триггер
   */
  readonly data: TriggerResponseDto
}>
/**
 * Запрос на чтение триггера
 */
export type GetTriggerRequestDto = {
  /**
   * Идентификатор триггера
   */
  id: number
}
/**
 * Ответ на чтение триггера
 */
export type GetTriggerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Триггер
   */
  readonly data: TriggerResponseDto
}>
/**
 * Запрос на погашение алерта
 */
export type PostTriggerAlertDisableRequestDto = {
  /**
   * Идентификатор алерта
   */
  id: number
  /**
   * Причина принудительного закрытия, заполняется в момент принудительного закрытия
   */
  closingReason?: string | null
}
/**
 * Ответ на запрос погашение алерта
 */
export type PostTriggerAlertDisableResponseDto = {
}
/**
 * Запрос на создание триггера
 */
export type PostTriggerRequestDto = {
  /**
   * Триггер, который хотим создать или обновить
   */
  data: TriggerRequestDto
}
/**
 * Ответ на запрос сохранения триггера
 */
export type PostTriggerResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Триггер, созданный или обновленный
   */
  readonly data: TriggerResponseDto
}>
/**
 * Триггер
 */
export type TriggerRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Название триггера
   */
  title: string
  /**
   * Тип критерия триггера
   */
  criteriaType: TriggerCriteriaTypeRequestEnum
  /**
   * Пороговое значение триггера
   */
  threshold: number
  /**
   * Тип периода контроля
   */
  periodType: TriggerPeriodTypeRequestEnum
  /**
   * Уровень критичности проблемы, которая описана критерием.
   * Задает приоритет оповещения и реагирования
   */
  severityType: TriggerSeverityTypeRequestEnum
  /**
   * Флаг активности триггера.
   * При погашении триггера гасятся и все его алерты
   */
  isDisabled: boolean
  /**
   * Краткая инструкция по решению или эскалации проблемы
   */
  instruction?: string | null
  /**
   * Фильтрация метрик по типам метрик.
   * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
   */
  metricTypes?: TriggerMetricTypeRequestEnum[]
  /**
   * Фильтрация метрик по значению моделей устройств.
   * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
   */
  deviceModels?: string[]
  /**
   * Фильтрация метрик по значению типов устройств.
   * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
   */
  deviceTypes?: TriggerDeviceTypeRequestEnum[]
  /**
   * Тип группировки метрик при вычислении критерия
   */
  metricGroupingType?: TriggerMetricGroupingTypeRequestEnum | "METRIC_GROUPING_TYPE_UNKNOWN"
  /**
   * Количество отрицательных проверок критерия, после которого сервис отключает
   */
  successThreshold?: number
  /**
   * Произвольные теги для фильтрации и упорядочивания
   */
  tags?: string[]
  /**
   * Флаг невозможности погашения алертов этого триггера
   */
  isManuallyUnclosable?: boolean
  /**
   * Признак контроля триггером временного окна выборки метрик на основе поля индикатора metric_expected_freq.
   * При значении true: поля range.sliding_days, range.fixed_days_range игнорируются при работе триггера.
   * При значении true: временное окно выборки метрик при работе триггера работает как sliding_days=indicator.metric_expected_freq.
   * При значении true: Для случаев indicator.metric_expected_freq=null индикатор игнорируется при работе триггера, алерт по нему не создается.
   * При значении true: Для случаев indicator.metric_expected_freq<=0 индикатор игнорируется при работе триггера, алерт по нему не создается
   */
  isRangeMetricExpectedFreq?: boolean
}
/**
 * range
 */
& fm.OptionalOneOf<{
  /**
   * Скользящее окно относительно текущего момента.
   * Начало окна это 00:00:00.000 UTC дня на sliding_days раньше текущего UTC дня.
   * Конец окна - текущий момент
   */
  readonly slidingDays: number
  /**
   * Границы временного окна, в текущем или предыдущем месяце
   */
  readonly fixedDaysRange: TriggerFixedDaysOfMonthRequestDto
}>
/**
 * Триггер
 */
export type TriggerResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Название триггера
   */
  title: string
  /**
   * Тип критерия триггера
   */
  criteriaType: TriggerCriteriaTypeResponseEnum
  /**
   * Пороговое значение триггера
   */
  threshold: number
  /**
   * Тип периода контроля
   */
  periodType: TriggerPeriodTypeResponseEnum
  /**
   * Уровень критичности проблемы, которая описана критерием.
   * Задает приоритет оповещения и реагирования
   */
  severityType: TriggerSeverityTypeResponseEnum
  /**
   * Флаг активности триггера.
   * При погашении триггера гасятся и все его алерты
   */
  isDisabled: boolean
  /**
   * Краткая инструкция по решению или эскалации проблемы
   */
  instruction: string | null
  /**
   * Фильтрация метрик по типам метрик.
   * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
   */
  metricTypes: TriggerMetricTypeResponseEnum[]
  /**
   * Фильтрация метрик по значению моделей устройств.
   * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
   */
  deviceModels: string[]
  /**
   * Фильтрация метрик по значению типов устройств.
   * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
   */
  deviceTypes: TriggerDeviceTypeResponseEnum[]
  /**
   * Тип группировки метрик при вычислении критерия
   */
  metricGroupingType: TriggerMetricGroupingTypeResponseEnum
  /**
   * Количество отрицательных проверок критерия, после которого сервис отключает
   */
  successThreshold: number
  /**
   * Произвольные теги для фильтрации и упорядочивания
   */
  tags: string[]
  /**
   * Флаг невозможности погашения алертов этого триггера
   */
  isManuallyUnclosable: boolean
  /**
   * Признак контроля триггером временного окна выборки метрик на основе поля индикатора metric_expected_freq.
   * При значении true: поля range.sliding_days, range.fixed_days_range игнорируются при работе триггера.
   * При значении true: временное окно выборки метрик при работе триггера работает как sliding_days=indicator.metric_expected_freq.
   * При значении true: Для случаев indicator.metric_expected_freq=null индикатор игнорируется при работе триггера, алерт по нему не создается.
   * При значении true: Для случаев indicator.metric_expected_freq<=0 индикатор игнорируется при работе триггера, алерт по нему не создается
   */
  isRangeMetricExpectedFreq: boolean
}
/**
 * range
 */
& fm.OneOf<{
  /**
   * Скользящее окно относительно текущего момента.
   * Начало окна это 00:00:00.000 UTC дня на sliding_days раньше текущего UTC дня.
   * Конец окна - текущий момент
   */
  readonly slidingDays: number
  /**
   * Границы временного окна, в текущем или предыдущем месяце
   */
  readonly fixedDaysRange: TriggerFixedDaysOfMonthResponseDto
}>
/**
 * Определение проблемы, сгенерированной по триггеру
 */
export type TriggerAlertRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Породивший триггер
   */
  triggerId: number
  /**
   * ФИАС
   */
  fiasId: string
  /**
   * Время возникновения алерта
   */
  raisedAt: string
  /**
   * Признак погашенного алерта.
   * Проставляется сервисом при no_alarm_checks_count >= success_threshold
   */
  isDisabled: boolean
  /**
   * Количество проверок триггера для атрибутов данного алерта, при которых не выполнился критерий триггера.
   * Увеличивается у непогашенного алерта, если при очередной проверке нет срабатывания триггера с атрибутами данного алерта.
   * При увеличении проставляется changed_at
   */
  noAlarmChecksCount: number
  /**
   * Типы метрик, по которым были отфильтрованы метрики
   */
  triggerMetricTypes?: TriggerMetricTypeRequestEnum[]
  /**
   * Модели устройств, по которым были отфильтрованы метрики
   */
  deviceModels?: string[]
  /**
   * Типы устройств, по которым были отфильтрованы метрики
   */
  triggerDeviceTypes?: TriggerDeviceTypeRequestEnum[]
  /**
   * Идентификаторы родительских устройств, по которому были сгруппированы метрики
   */
  deviceParentId?: number | null
  /**
   * Время погашения алерта.
   * Пустой или отсутствует у непогашенного активного алерта
   */
  closedAt?: string | null
  /**
   * Признак принудительного погашения алерта
   */
  isManuallyClosed?: boolean
  /**
   * Причина принудительного закрытия, заполняется в момент принудительного закрытия
   */
  closingReason?: string | null
  /**
   * Группировка метрик при вычислении критерия
   */
  triggerMetricGroupingType?: TriggerMetricGroupingTypeRequestEnum | "METRIC_GROUPING_TYPE_UNKNOWN"
}
/**
 * Определение проблемы, сгенерированной по триггеру
 */
export type TriggerAlertResponseDto = {
  /**
   * Идентификатор
   */
  readonly id: number
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта
   */
  readonly changedAt: string
  /**
   * Породивший триггер
   */
  triggerId: number
  /**
   * ФИАС
   */
  fiasId: string
  /**
   * Время возникновения алерта
   */
  raisedAt: string
  /**
   * Признак погашенного алерта.
   * Проставляется сервисом при no_alarm_checks_count >= success_threshold
   */
  isDisabled: boolean
  /**
   * Количество проверок триггера для атрибутов данного алерта, при которых не выполнился критерий триггера.
   * Увеличивается у непогашенного алерта, если при очередной проверке нет срабатывания триггера с атрибутами данного алерта.
   * При увеличении проставляется changed_at
   */
  noAlarmChecksCount: number
  /**
   * Типы метрик, по которым были отфильтрованы метрики
   */
  triggerMetricTypes: TriggerMetricTypeResponseEnum[]
  /**
   * Модели устройств, по которым были отфильтрованы метрики
   */
  deviceModels: string[]
  /**
   * Типы устройств, по которым были отфильтрованы метрики
   */
  triggerDeviceTypes: TriggerDeviceTypeResponseEnum[]
  /**
   * Идентификаторы родительских устройств, по которому были сгруппированы метрики
   */
  deviceParentId: number | null
  /**
   * Время погашения алерта.
   * Пустой или отсутствует у непогашенного активного алерта
   */
  closedAt: string | null
  /**
   * Признак принудительного погашения алерта
   */
  isManuallyClosed: boolean
  /**
   * Причина принудительного закрытия, заполняется в момент принудительного закрытия
   */
  closingReason: string | null
  /**
   * Группировка метрик при вычислении критерия
   */
  triggerMetricGroupingType: TriggerMetricGroupingTypeResponseEnum
}
/**
 * Границы временного окна, в текущем или предыдущем месяце.
 * Если end_day текущего месяца не наступил, то берем прошлый месяц
 */
export type TriggerFixedDaysOfMonthRequestDto = {
  /**
   * Начало окна времени.
   * Номер дня месяца, момент времени 00:00:00.000 UTC
   */
  startDay?: number
  /**
   * Конец окна времени.
   * Номер дня месяца, момент времени 00:00:00.000 UTC
   */
  endDay?: number
}
/**
 * Границы временного окна, в текущем или предыдущем месяце.
 * Если end_day текущего месяца не наступил, то берем прошлый месяц
 */
export type TriggerFixedDaysOfMonthResponseDto = {
  /**
   * Начало окна времени.
   * Номер дня месяца, момент времени 00:00:00.000 UTC
   */
  startDay: number
  /**
   * Конец окна времени.
   * Номер дня месяца, момент времени 00:00:00.000 UTC
   */
  endDay: number
}
/**
 * Параметры фильтрации алертов.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type TriggerAlertFilterRequestDto = {
  /**
   * По важности триггера
   */
  triggerSeverityTypes?: TriggerSeverityTypeResponseEnum[]
  /**
   * По ФИАСам
   */
  fiasIds?: string[]
  /**
   * По тэгам
   */
  tags?: string[]
  /**
   * По типам метрик триггера
   */
  metricTypes?: TriggerMetricTypeResponseEnum[]
  /**
   * По моделям устройств
   */
  deviceModels?: string[]
  /**
   * По типам устройств
   */
  deviceTypes?: TriggerDeviceTypeResponseEnum[]
  /**
   * По идентификаторам родительских устройств
   */
  deviceParentIds?: number[]
  /**
   * По идентификаторам устройств
   */
  deviceIds?: number[]
  /**
   * По признаку активности
   */
  isDisabled?: boolean | null
  /**
   * От даты возникновения включительно (>=)
   */
  afterRaisedAt?: string | null
  /**
   * До даты возникновения (<)
   */
  beforeRaisedAt?: string | null
  /**
   * По типам группировки метрик
   */
  metricGroupingTypes?: TriggerMetricGroupingTypeResponseEnum[]
  /**
   * По идентификаторам триггеров
   */
  triggerIds?: number[]
}
/**
 * Параметры фильтрации алертов.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type TriggerAlertFilterResponseDto = {
  /**
   * По важности триггера
   */
  triggerSeverityTypes: TriggerSeverityTypeResponseEnum[]
  /**
   * По ФИАСам
   */
  fiasIds: string[]
  /**
   * По тэгам
   */
  tags: string[]
  /**
   * По типам метрик триггера
   */
  metricTypes: TriggerMetricTypeResponseEnum[]
  /**
   * По моделям устройств
   */
  deviceModels: string[]
  /**
   * По типам устройств
   */
  deviceTypes: TriggerDeviceTypeResponseEnum[]
  /**
   * По идентификаторам родительских устройств
   */
  deviceParentIds: number[]
  /**
   * По идентификаторам устройств
   */
  deviceIds: number[]
  /**
   * По признаку активности
   */
  isDisabled: boolean | null
  /**
   * От даты возникновения включительно (>=)
   */
  afterRaisedAt: string | null
  /**
   * До даты возникновения (<)
   */
  beforeRaisedAt: string | null
  /**
   * По типам группировки метрик
   */
  metricGroupingTypes: TriggerMetricGroupingTypeResponseEnum[]
  /**
   * По идентификаторам триггеров
   */
  triggerIds: number[]
}
/**
 * Параметры пагинации алертов
 */
export type TriggerAlertPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ORDER_BY_TYPE_RAISED_AT
   */
  orderByType?: TriggerAlertPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: TriggerAlertPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Сколько элементов нужно получить за раз.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Начальный сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Параметры пагинации алертов
 */
export type TriggerAlertPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ORDER_BY_TYPE_RAISED_AT
   */
  orderByType: TriggerAlertPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: TriggerAlertPagingDirectionTypeResponseEnum
  /**
   * Сколько элементов нужно получить за раз.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Начальный сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Параметры фильтрации триггеров.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type TriggerFilterRequestDto = {
  /**
   * По уровням критичности
   */
  severityTypes?: TriggerSeverityTypeResponseEnum[]
  /**
   * По тэгам
   */
  tags?: string[]
  /**
   * По типам метрик триггеров
   */
  metricTypes?: TriggerMetricTypeResponseEnum[]
  /**
   * По моделям устройств
   */
  deviceModels?: string[]
  /**
   * По типам устройств
   */
  deviceTypes?: TriggerDeviceTypeResponseEnum[]
  /**
   * По типам группировки метрик
   */
  metricGroupingTypes?: TriggerMetricGroupingTypeResponseEnum[]
  /**
   * По признаку активности триггера
   */
  isDisabled?: boolean | null
}
/**
 * Параметры фильтрации триггеров.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type TriggerFilterResponseDto = {
  /**
   * По уровням критичности
   */
  severityTypes: TriggerSeverityTypeResponseEnum[]
  /**
   * По тэгам
   */
  tags: string[]
  /**
   * По типам метрик триггеров
   */
  metricTypes: TriggerMetricTypeResponseEnum[]
  /**
   * По моделям устройств
   */
  deviceModels: string[]
  /**
   * По типам устройств
   */
  deviceTypes: TriggerDeviceTypeResponseEnum[]
  /**
   * По типам группировки метрик
   */
  metricGroupingTypes: TriggerMetricGroupingTypeResponseEnum[]
  /**
   * По признаку активности триггера
   */
  isDisabled: boolean | null
}
/**
 * Параметры пагинации триггеров
 */
export type TriggerPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: SEVERITY
   */
  orderByType?: TriggerPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: ASC
   */
  directionType?: TriggerPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Сколько элементов нужно получить за раз.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Начальный сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Параметры пагинации триггеров
 */
export type TriggerPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: SEVERITY
   */
  orderByType: TriggerPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: ASC
   */
  directionType: TriggerPagingDirectionTypeResponseEnum
  /**
   * Сколько элементов нужно получить за раз.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Начальный сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Факты сработки алерта на устройствах
   */
  "AlertDevice": {
    "kind": "class",
    "text": "Факты сработки алерта на устройствах",
    "fields": {
      /**
       * Идентификатор алерта
       */
      "alertId": {
        "type": "int32",
        "text": "Идентификатор алерта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Запрос на удаление алерта
   */
  "DeleteTriggerAlertRequest": {
    "kind": "class",
    "text": "Запрос на удаление алерта",
    "fields": {
      /**
       * Идентификатор алерта
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор алерта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаление алерта
   */
  "DeleteTriggerAlertResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаление алерта",
  },
  /**
   * Запрос на удаление триггера
   */
  "DeleteTriggerRequest": {
    "kind": "class",
    "text": "Запрос на удаление триггера",
    "fields": {
      /**
       * Идентификатор триггера
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор триггера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаление триггера
   */
  "DeleteTriggerResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаление триггера",
  },
  /**
   * Запрос получения списка алертов
   */
  "GetTriggerAlertCountRequest": {
    "kind": "class",
    "text": "Запрос получения списка алертов",
    "fields": {
      /**
       * Параметры фильтрации
       */
      "filter": {
        "type": "TriggerAlertFilter",
        "text": "Параметры фильтрации",
      },
    },
  },
  /**
   * Ответ на запрос получения количества записей
   */
  "GetTriggerAlertCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества записей",
    "fields": {
      /**
       * Всего записей
       */
      "data": {
        "type": "int32",
        "text": "Всего записей",
      },
    },
  },
  /**
   * Запрос списка устройств, вызвавших появление алерта
   */
  "GetTriggerAlertDeviceListRequest": {
    "kind": "class",
    "text": "Запрос списка устройств, вызвавших появление алерта",
    "fields": {
      /**
       * Идентификатор алерта
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор алерта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметры фильтрации алерта
       */
      "filter": {
        "type": "TriggerAlertFilter",
        "text": "Параметры фильтрации алерта",
      },
      /**
       * Параметры пагинации
       */
      "paging": {
        "type": "TriggerAlertPaging",
        "text": "Параметры пагинации",
      },
    },
  },
  /**
   * Ответ на запрос списка устройств, вызвавших появление алерта
   */
  "GetTriggerAlertDeviceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос списка устройств, вызвавших появление алерта",
    "fields": {
      /**
       * Факт сработки триггера
       */
      "data": {
        "type": "AlertDevice",
        "text": "Факт сработки триггера",
      },
    },
  },
  /**
   * Запрос получения списка алертов
   */
  "GetTriggerAlertListRequest": {
    "kind": "class",
    "text": "Запрос получения списка алертов",
    "fields": {
      /**
       * Параметры фильтрации
       */
      "filter": {
        "type": "TriggerAlertFilter",
        "text": "Параметры фильтрации",
      },
      /**
       * Параметры пагинации
       */
      "paging": {
        "type": "TriggerAlertPaging",
        "text": "Параметры пагинации",
      },
    },
  },
  /**
   * Ответ на запрос получения списка записей
   */
  "GetTriggerAlertListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка записей",
    "fields": {
      /**
       * Алерт
       */
      "data": {
        "type": "Trigger.Alert",
        "text": "Алерт",
      },
    },
  },
  /**
   * Запрос получения количества записей
   */
  "GetTriggerCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества записей",
    "fields": {
      /**
       * Параметры фильтрации
       */
      "filter": {
        "type": "TriggerFilter",
        "text": "Параметры фильтрации",
      },
    },
  },
  /**
   * Ответ на запрос получения количества записей
   */
  "GetTriggerCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества записей",
    "fields": {
      /**
       * Всего записей
       */
      "data": {
        "type": "int32",
        "text": "Всего записей",
      },
    },
  },
  /**
   * Запрос получения списка триггеров
   */
  "GetTriggerListRequest": {
    "kind": "class",
    "text": "Запрос получения списка триггеров",
    "fields": {
      /**
       * Параметры фильтрации
       */
      "filter": {
        "type": "TriggerFilter",
        "text": "Параметры фильтрации",
      },
      /**
       * Параметры пагинации
       */
      "paging": {
        "type": "TriggerPaging",
        "text": "Параметры пагинации",
      },
    },
  },
  /**
   * Ответ на запрос получения списка записей
   */
  "GetTriggerListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка записей",
    "fields": {
      /**
       * Триггер
       */
      "data": {
        "type": "Trigger",
        "text": "Триггер",
      },
    },
  },
  /**
   * Запрос на чтение триггера
   */
  "GetTriggerRequest": {
    "kind": "class",
    "text": "Запрос на чтение триггера",
    "fields": {
      /**
       * Идентификатор триггера
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор триггера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на чтение триггера
   */
  "GetTriggerResponse": {
    "kind": "class",
    "text": "Ответ на чтение триггера",
    "fields": {
      /**
       * Триггер
       */
      "data": {
        "type": "Trigger",
        "text": "Триггер",
      },
    },
  },
  /**
   * Запрос на погашение алерта
   */
  "PostTriggerAlertDisableRequest": {
    "kind": "class",
    "text": "Запрос на погашение алерта",
    "fields": {
      /**
       * Идентификатор алерта
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор алерта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Причина принудительного закрытия, заполняется в момент принудительного закрытия
       */
      "closingReason": {
        "type": "google.protobuf.StringValue",
        "text": "Причина принудительного закрытия, заполняется в момент принудительного закрытия",
      },
    },
  },
  /**
   * Ответ на запрос погашение алерта
   */
  "PostTriggerAlertDisableResponse": {
    "kind": "class",
    "text": "Ответ на запрос погашение алерта",
  },
  /**
   * Запрос на создание триггера
   */
  "PostTriggerRequest": {
    "kind": "class",
    "text": "Запрос на создание триггера",
    "fields": {
      /**
       * Триггер, который хотим создать или обновить
       */
      "data": {
        "type": "Trigger",
        "text": "Триггер, который хотим создать или обновить",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения триггера
   */
  "PostTriggerResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения триггера",
    "fields": {
      /**
       * Триггер, созданный или обновленный
       */
      "data": {
        "type": "Trigger",
        "text": "Триггер, созданный или обновленный",
      },
    },
  },
  /**
   * Триггер
   */
  "Trigger": {
    "kind": "class",
    "text": "Триггер",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Название триггера
       */
      "title": {
        "type": "string",
        "text": "Название триггера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип критерия триггера
       */
      "criteriaType": {
        "type": "Trigger.CriteriaType",
        "text": "Тип критерия триггера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пороговое значение триггера
       */
      "threshold": {
        "type": "float",
        "text": "Пороговое значение триггера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Скользящее окно относительно текущего момента.
       * Начало окна это 00:00:00.000 UTC дня на sliding_days раньше текущего UTC дня.
       * Конец окна - текущий момент
       */
      "slidingDays": {
        "type": "int32",
        "text": "Скользящее окно относительно текущего момента.\nНачало окна это 00:00:00.000 UTC дня на sliding_days раньше текущего UTC дня.\nКонец окна - текущий момент",
      },
      /**
       * Границы временного окна, в текущем или предыдущем месяце
       */
      "fixedDaysRange": {
        "type": "Trigger.FixedDaysOfMonth",
        "text": "Границы временного окна, в текущем или предыдущем месяце",
      },
      /**
       * Тип периода контроля
       */
      "periodType": {
        "type": "Trigger.PeriodType",
        "text": "Тип периода контроля",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Уровень критичности проблемы, которая описана критерием.
       * Задает приоритет оповещения и реагирования
       */
      "severityType": {
        "type": "Trigger.SeverityType",
        "text": "Уровень критичности проблемы, которая описана критерием.\nЗадает приоритет оповещения и реагирования",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Флаг активности триггера.
       * При погашении триггера гасятся и все его алерты
       */
      "isDisabled": {
        "type": "bool",
        "text": "Флаг активности триггера.\nПри погашении триггера гасятся и все его алерты",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Краткая инструкция по решению или эскалации проблемы
       */
      "instruction": {
        "type": "google.protobuf.StringValue",
        "text": "Краткая инструкция по решению или эскалации проблемы",
      },
      /**
       * Фильтрация метрик по типам метрик.
       * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
       */
      "metricTypes": {
        "type": "Trigger.MetricType",
        "text": "Фильтрация метрик по типам метрик.\nПри нескольких элементах фильтрация срабатывает по значениям через ИЛИ",
      },
      /**
       * Фильтрация метрик по значению моделей устройств.
       * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
       */
      "deviceModels": {
        "type": "string",
        "text": "Фильтрация метрик по значению моделей устройств.\nПри нескольких элементах фильтрация срабатывает по значениям через ИЛИ",
      },
      /**
       * Фильтрация метрик по значению типов устройств.
       * При нескольких элементах фильтрация срабатывает по значениям через ИЛИ
       */
      "deviceTypes": {
        "type": "Trigger.DeviceType",
        "text": "Фильтрация метрик по значению типов устройств.\nПри нескольких элементах фильтрация срабатывает по значениям через ИЛИ",
      },
      /**
       * Тип группировки метрик при вычислении критерия
       */
      "metricGroupingType": {
        "type": "Trigger.MetricGroupingType",
        "text": "Тип группировки метрик при вычислении критерия",
      },
      /**
       * Количество отрицательных проверок критерия, после которого сервис отключает
       */
      "successThreshold": {
        "type": "int32",
        "text": "Количество отрицательных проверок критерия, после которого сервис отключает",
      },
      /**
       * Произвольные теги для фильтрации и упорядочивания
       */
      "tags": {
        "type": "string",
        "text": "Произвольные теги для фильтрации и упорядочивания",
      },
      /**
       * Флаг невозможности погашения алертов этого триггера
       */
      "isManuallyUnclosable": {
        "type": "bool",
        "text": "Флаг невозможности погашения алертов этого триггера",
      },
      /**
       * Признак контроля триггером временного окна выборки метрик на основе поля индикатора metric_expected_freq.
       * При значении true: поля range.sliding_days, range.fixed_days_range игнорируются при работе триггера.
       * При значении true: временное окно выборки метрик при работе триггера работает как sliding_days=indicator.metric_expected_freq.
       * При значении true: Для случаев indicator.metric_expected_freq=null индикатор игнорируется при работе триггера, алерт по нему не создается.
       * При значении true: Для случаев indicator.metric_expected_freq<=0 индикатор игнорируется при работе триггера, алерт по нему не создается
       */
      "isRangeMetricExpectedFreq": {
        "type": "bool",
        "text": "Признак контроля триггером временного окна выборки метрик на основе поля индикатора metric_expected_freq.\nПри значении true: поля range.sliding_days, range.fixed_days_range игнорируются при работе триггера.\nПри значении true: временное окно выборки метрик при работе триггера работает как sliding_days=indicator.metric_expected_freq.\nПри значении true: Для случаев indicator.metric_expected_freq=null индикатор игнорируется при работе триггера, алерт по нему не создается.\nПри значении true: Для случаев indicator.metric_expected_freq<=0 индикатор игнорируется при работе триггера, алерт по нему не создается",
      },
    },
  },
  /**
   * Определение проблемы, сгенерированной по триггеру
   */
  "Trigger.Alert": {
    "kind": "class",
    "text": "Определение проблемы, сгенерированной по триггеру",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта",
      },
      /**
       * Породивший триггер
       */
      "triggerId": {
        "type": "int32",
        "text": "Породивший триггер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ФИАС
       */
      "fiasId": {
        "type": "string",
        "text": "ФИАС",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Время возникновения алерта
       */
      "raisedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Время возникновения алерта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Признак погашенного алерта.
       * Проставляется сервисом при no_alarm_checks_count >= success_threshold
       */
      "isDisabled": {
        "type": "bool",
        "text": "Признак погашенного алерта.\nПроставляется сервисом при no_alarm_checks_count >= success_threshold",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Количество проверок триггера для атрибутов данного алерта, при которых не выполнился критерий триггера.
       * Увеличивается у непогашенного алерта, если при очередной проверке нет срабатывания триггера с атрибутами данного алерта.
       * При увеличении проставляется changed_at
       */
      "noAlarmChecksCount": {
        "type": "int32",
        "text": "Количество проверок триггера для атрибутов данного алерта, при которых не выполнился критерий триггера.\nУвеличивается у непогашенного алерта, если при очередной проверке нет срабатывания триггера с атрибутами данного алерта.\nПри увеличении проставляется changed_at",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Типы метрик, по которым были отфильтрованы метрики
       */
      "triggerMetricTypes": {
        "type": "Trigger.MetricType",
        "text": "Типы метрик, по которым были отфильтрованы метрики",
      },
      /**
       * Модели устройств, по которым были отфильтрованы метрики
       */
      "deviceModels": {
        "type": "string",
        "text": "Модели устройств, по которым были отфильтрованы метрики",
      },
      /**
       * Типы устройств, по которым были отфильтрованы метрики
       */
      "triggerDeviceTypes": {
        "type": "Trigger.DeviceType",
        "text": "Типы устройств, по которым были отфильтрованы метрики",
      },
      /**
       * Идентификаторы родительских устройств, по которому были сгруппированы метрики
       */
      "deviceParentId": {
        "type": "google.protobuf.Int32Value",
        "text": "Идентификаторы родительских устройств, по которому были сгруппированы метрики",
      },
      /**
       * Время погашения алерта.
       * Пустой или отсутствует у непогашенного активного алерта
       */
      "closedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Время погашения алерта.\nПустой или отсутствует у непогашенного активного алерта",
      },
      /**
       * Признак принудительного погашения алерта
       */
      "isManuallyClosed": {
        "type": "bool",
        "text": "Признак принудительного погашения алерта",
      },
      /**
       * Причина принудительного закрытия, заполняется в момент принудительного закрытия
       */
      "closingReason": {
        "type": "google.protobuf.StringValue",
        "text": "Причина принудительного закрытия, заполняется в момент принудительного закрытия",
      },
      /**
       * Группировка метрик при вычислении критерия
       */
      "triggerMetricGroupingType": {
        "type": "Trigger.MetricGroupingType",
        "text": "Группировка метрик при вычислении критерия",
      },
    },
  },
  /**
   * Границы временного окна, в текущем или предыдущем месяце.
   * Если end_day текущего месяца не наступил, то берем прошлый месяц
   */
  "Trigger.FixedDaysOfMonth": {
    "kind": "class",
    "text": "Границы временного окна, в текущем или предыдущем месяце.\nЕсли end_day текущего месяца не наступил, то берем прошлый месяц",
    "fields": {
      /**
       * Начало окна времени.
       * Номер дня месяца, момент времени 00:00:00.000 UTC
       */
      "startDay": {
        "type": "int32",
        "text": "Начало окна времени.\nНомер дня месяца, момент времени 00:00:00.000 UTC",
      },
      /**
       * Конец окна времени.
       * Номер дня месяца, момент времени 00:00:00.000 UTC
       */
      "endDay": {
        "type": "int32",
        "text": "Конец окна времени.\nНомер дня месяца, момент времени 00:00:00.000 UTC",
      },
    },
  },
  /**
   * Параметры фильтрации алертов.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "TriggerAlertFilter": {
    "kind": "class",
    "text": "Параметры фильтрации алертов.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По важности триггера
       */
      "triggerSeverityTypes": {
        "type": "Trigger.SeverityType",
        "text": "По важности триггера",
      },
      /**
       * По ФИАСам
       */
      "fiasIds": {
        "type": "string",
        "text": "По ФИАСам",
      },
      /**
       * По тэгам
       */
      "tags": {
        "type": "string",
        "text": "По тэгам",
      },
      /**
       * По типам метрик триггера
       */
      "metricTypes": {
        "type": "Trigger.MetricType",
        "text": "По типам метрик триггера",
      },
      /**
       * По моделям устройств
       */
      "deviceModels": {
        "type": "string",
        "text": "По моделям устройств",
      },
      /**
       * По типам устройств
       */
      "deviceTypes": {
        "type": "Trigger.DeviceType",
        "text": "По типам устройств",
      },
      /**
       * По идентификаторам родительских устройств
       */
      "deviceParentIds": {
        "type": "int32",
        "text": "По идентификаторам родительских устройств",
      },
      /**
       * По идентификаторам устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам устройств",
      },
      /**
       * По признаку активности
       */
      "isDisabled": {
        "type": "google.protobuf.BoolValue",
        "text": "По признаку активности",
      },
      /**
       * От даты возникновения включительно (>=)
       */
      "afterRaisedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты возникновения включительно (>=)",
      },
      /**
       * До даты возникновения (<)
       */
      "beforeRaisedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты возникновения (<)",
      },
      /**
       * По типам группировки метрик
       */
      "metricGroupingTypes": {
        "type": "Trigger.MetricGroupingType",
        "text": "По типам группировки метрик",
      },
      /**
       * По идентификаторам триггеров
       */
      "triggerIds": {
        "type": "int32",
        "text": "По идентификаторам триггеров",
      },
    },
  },
  /**
   * Параметры пагинации алертов
   */
  "TriggerAlertPaging": {
    "kind": "class",
    "text": "Параметры пагинации алертов",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ORDER_BY_TYPE_RAISED_AT
       */
      "orderByType": {
        "type": "TriggerAlertPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ORDER_BY_TYPE_RAISED_AT",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "TriggerAlertPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Сколько элементов нужно получить за раз.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Сколько элементов нужно получить за раз.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Начальный сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Начальный сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Параметры фильтрации триггеров.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "TriggerFilter": {
    "kind": "class",
    "text": "Параметры фильтрации триггеров.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По уровням критичности
       */
      "severityTypes": {
        "type": "Trigger.SeverityType",
        "text": "По уровням критичности",
      },
      /**
       * По тэгам
       */
      "tags": {
        "type": "string",
        "text": "По тэгам",
      },
      /**
       * По типам метрик триггеров
       */
      "metricTypes": {
        "type": "Trigger.MetricType",
        "text": "По типам метрик триггеров",
      },
      /**
       * По моделям устройств
       */
      "deviceModels": {
        "type": "string",
        "text": "По моделям устройств",
      },
      /**
       * По типам устройств
       */
      "deviceTypes": {
        "type": "Trigger.DeviceType",
        "text": "По типам устройств",
      },
      /**
       * По типам группировки метрик
       */
      "metricGroupingTypes": {
        "type": "Trigger.MetricGroupingType",
        "text": "По типам группировки метрик",
      },
      /**
       * По признаку активности триггера
       */
      "isDisabled": {
        "type": "google.protobuf.BoolValue",
        "text": "По признаку активности триггера",
      },
    },
  },
  /**
   * Параметры пагинации триггеров
   */
  "TriggerPaging": {
    "kind": "class",
    "text": "Параметры пагинации триггеров",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: SEVERITY
       */
      "orderByType": {
        "type": "TriggerPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: SEVERITY",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: ASC
       */
      "directionType": {
        "type": "TriggerPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: ASC",
      },
      /**
       * Сколько элементов нужно получить за раз.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Сколько элементов нужно получить за раз.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Начальный сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Начальный сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Справочник типов критерия триггера.
   * Задает параметры критерия, правила поиска проблемы и генерации алерта
   */
  "Trigger.CriteriaType": {
    "kind": "enum",
    "text": "Справочник типов критерия триггера.\nЗадает параметры критерия, правила поиска проблемы и генерации алерта",
    "values": {
      /**
       * Значение не указано
       */
      "CRITERIA_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Количество метрик меньше порога
       */
      "METRICS_COUNT": {
        "i": 1,
        "text": "Количество метрик меньше порога",
      },
      /**
       * Доля работающих устройств в группе меньше порога
       */
      "DEVICE_PERCENT": {
        "i": 2,
        "text": "Доля работающих устройств в группе меньше порога",
      },
      /**
       * Превышение порога дисперсии значений показаний
       */
      "METRICS_VALUE_DEVIATION": {
        "i": 3,
        "text": "Превышение порога дисперсии значений показаний",
      },
    },
  },
  /**
   * Справочник типов ПУ
   */
  "Trigger.DeviceType": {
    "kind": "enum",
    "text": "Справочник типов ПУ",
    "values": {
      /**
       * Значение не указано
       */
      "DEVICE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Коммуникационный модуль
       */
      "HUB": {
        "i": 1,
        "text": "Коммуникационный модуль",
      },
      /**
       * Счетчик импульсов - регистратор
       */
      "PULSE_COUNTER_RECORDER": {
        "i": 2,
        "text": "Счетчик импульсов - регистратор",
      },
      /**
       * Счетчик импульсов - регистратор LoRaWAN
       */
      "PULSE_COUNTER_RECORDER_LR": {
        "i": 3,
        "text": "Счетчик импульсов - регистратор LoRaWAN",
      },
      /**
       * Прибор учета расхода коммунальных услуг
       */
      "METERING_DEVICE": {
        "i": 4,
        "text": "Прибор учета расхода коммунальных услуг",
      },
      /**
       * Конвертер интерфейсов
       */
      "INTERFACE_CONVERTER": {
        "i": 5,
        "text": "Конвертер интерфейсов",
      },
      /**
       * M-BUS концентратор
       */
      "M_BUS_HUB": {
        "i": 6,
        "text": "M-BUS концентратор",
      },
      /**
       * Модуль связи LoRaWAN
       */
      "COMMUNICATION_MODULE_LR": {
        "i": 7,
        "text": "Модуль связи LoRaWAN",
      },
      /**
       * Базовая станция LoRaWAN
       */
      "BASE_LR": {
        "i": 8,
        "text": "Базовая станция LoRaWAN",
      },
    },
  },
  /**
   * Типы группировок метрик при вычислении критерия
   */
  "Trigger.MetricGroupingType": {
    "kind": "enum",
    "text": "Типы группировок метрик при вычислении критерия",
    "values": {
      /**
       * Значение не указано
       */
      "METRIC_GROUPING_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Признак группировки метрик по идентификаторам родительского устройства(идентификатор хаба, проксирующего прибор учета)
       */
      "PARENT_ID": {
        "i": 1,
        "text": "Признак группировки метрик по идентификаторам родительского устройства(идентификатор хаба, проксирующего прибор учета)",
      },
      /**
       * Признак группировки метрик по идентификатору устройства(устройство, с которого получена метрика)
       */
      "DEVICE_ID": {
        "i": 2,
        "text": "Признак группировки метрик по идентификатору устройства(устройство, с которого получена метрика)",
      },
    },
  },
  /**
   * Справочник типов энергоресурсов, собираемых ТУ
   */
  "Trigger.MetricType": {
    "kind": "enum",
    "text": "Справочник типов энергоресурсов, собираемых ТУ",
    "values": {
      /**
       * Значение не указано
       */
      "METRIC_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Горячая вода
       */
      "HOT_WATER": {
        "i": 1,
        "text": "Горячая вода",
      },
      /**
       * Холодная вода
       */
      "COLD_WATER": {
        "i": 2,
        "text": "Холодная вода",
      },
      /**
       * Теплоэнергия
       */
      "HEAT": {
        "i": 3,
        "text": "Теплоэнергия",
      },
      /**
       * Газ
       */
      "GAS": {
        "i": 4,
        "text": "Газ",
      },
      /**
       * Электроэнергия
       */
      "ELECTRICITY": {
        "i": 5,
        "text": "Электроэнергия",
      },
    },
  },
  /**
   * Справочник типов периодов контроля триггера
   */
  "Trigger.PeriodType": {
    "kind": "enum",
    "text": "Справочник типов периодов контроля триггера",
    "values": {
      /**
       * Значение не указано
       */
      "PERIOD_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * День
       */
      "DAY": {
        "i": 1,
        "text": "День",
      },
      /**
       * Месяц
       */
      "MONTH": {
        "i": 2,
        "text": "Месяц",
      },
    },
  },
  /**
   * Справочник типов уровней критичности
   */
  "Trigger.SeverityType": {
    "kind": "enum",
    "text": "Справочник типов уровней критичности",
    "values": {
      /**
       * Значение не указано
       */
      "SEVERITY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Проблема высшего приоритета.
       * Максимальное оповещение
       */
      "CRITICAL": {
        "i": 1,
        "text": "Проблема высшего приоритета.\nМаксимальное оповещение",
      },
      /**
       * Проблема среднего приоритета.
       * Оповещение по внутренним каналам
       */
      "WARNING": {
        "i": 2,
        "text": "Проблема среднего приоритета.\nОповещение по внутренним каналам",
      },
      /**
       * Проблема не влияет на бизнес-пользователя.
       * Отражается во внутренних интерфейсах
       */
      "INFO": {
        "i": 3,
        "text": "Проблема не влияет на бизнес-пользователя.\nОтражается во внутренних интерфейсах",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "TriggerAlertPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "TriggerAlertPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По дате возникновения
       */
      "RAISED_AT": {
        "i": 1,
        "text": "По дате возникновения",
      },
      /**
       * По идентификатору триггера
       */
      "TRIGGER_ID": {
        "i": 2,
        "text": "По идентификатору триггера",
      },
      /**
       * По заголовку триггера
       */
      "TITLE": {
        "i": 3,
        "text": "По заголовку триггера",
      },
      /**
       * По флагу активности триггера
       */
      "DISABLED": {
        "i": 4,
        "text": "По флагу активности триггера",
      },
      /**
       * По триггеру
       */
      "SEVERITY": {
        "i": 5,
        "text": "По триггеру",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "TriggerPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "TriggerPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По заголовку
       */
      "TITLE": {
        "i": 2,
        "text": "По заголовку",
      },
      /**
       * По флагу активности
       */
      "DISABLED": {
        "i": 3,
        "text": "По флагу активности",
      },
      /**
       * По Severity
       */
      "SEVERITY": {
        "i": 4,
        "text": "По Severity",
      },
    },
  },
}